import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { KeyValueObject } from '../../../models/core/KeyValueObject';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { SetPerformerGroupModel } from './set-performer-group.model';
import { WorkflowTransition } from '../../../models/request/workflow-transition';
import { RequestResultSettingsService } from '../../../services/request-result-settings.service';

@Component({
	selector: 'set-performer-group',
	templateUrl: './set-performer-group.html',
	styleUrls: ['./set-performer-group.scss']
})
export class SetPerformerGroup implements OnInit {

	public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

	@Output()
	onContinueEvent = new EventEmitter<SetPerformerGroupModel>();

	users: KeyValueObject[] = [];

	@Input()
	setPerformerGroupModel: SetPerformerGroupModel;

	@Input()
	requestId: number;

	@Input()
	workflowTransition: WorkflowTransition;

	@Input()
	requestTypeId: number;

	@Input()
	customerContragentId: number;

	requestResults: KeyValueObject[] = [];
	selectedRequestResultId: number = null;
	dataSaving: boolean = false;

	get showRequestResult(): boolean {
		return this.requestResults && this.requestResults.length > 0;
	}

	constructor(
		public dialog: DialogRef,
		private requestResultSettingsService: RequestResultSettingsService
	) {}

	ngOnInit(): void {
		this.loadRequestResults();
	}

	private loadRequestResults(): void {
		if (this.requestTypeId) {
			this.requestResultSettingsService.getByRequest(this.requestTypeId, this.customerContragentId)
				.subscribe(data => {
					this.requestResults = data;
				});
		}
	}

	cancel() {
		this.dialog.close();
	}

	continue() {
		this.dataSaving = true;

		if (this.showRequestResult && this.selectedRequestResultId) {
			this.requestResultSettingsService.saveRequestResult(this.requestId, this.selectedRequestResultId)
				.subscribe(() => {
					this.emitAndClose();
				});
		} else {
			this.emitAndClose();
		}
	}

	private emitAndClose(): void {
		this.onContinueEvent.emit(this.setPerformerGroupModel);
		this.dataSaving = false;
		this.dialog.close();
	}
}
